

















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { imageUrl } from '@/shared/utils/images'

@Component({
  data() {
    return {
      currentImage: undefined,
    }
  },
})
export default class RespondecoBackgroundImage extends Vue {
  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly cover!: boolean

  @Prop({
    type: Number,
  })
  public readonly height?: number

  @Prop({
    type: String,
  })
  public readonly image!: string

  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly notRound!: boolean

  @Prop({
    type: Number,
  })
  public readonly width?: number

  /**
   * Image url that is displayed
   */
  public currentImage!: string

  @Watch('image', {
    immediate: true,
  })
  public imageChanged(value: string) {
    this.currentImage = imageUrl(value, this.width, this.height)
  }
}
